"use client"; // Error components must be Client Components

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import Link from "next/link";
import "./[locale]/globals.css";

// biome-ignore lint: Exporting Error is required by Next.js
export default function Error() {
    return (
        <html lang="en">
            <body className="dark flex min-h-screen items-center justify-center p-4">
                <Card className="w-full max-w-md shadow-lg">
                    <CardHeader className="text-center">
                        <div className="mx-auto mb-4 flex size-20 items-center justify-center rounded-full bg-muted">
                            <AlertTriangle className="size-8 text-muted-foreground" />
                        </div>
                        <div className="flex items-center justify-center gap-2">
                            <h1 className="font-bold text-2xl">Error</h1>
                        </div>
                    </CardHeader>
                    <CardContent className="text-center">
                        <h2 className="mb-2 font-bold text-xl">Something went wrong!</h2>
                        <p className="text-muted-foreground">
                            An unexpected error occurred. Please try refreshing the page or contact support if the
                            problem persists.
                        </p>
                    </CardContent>
                    <CardFooter>
                        <Button asChild className="w-full">
                            <Link href="/home">
                                <span>←</span>
                                Go Back Home
                            </Link>
                        </Button>
                    </CardFooter>
                </Card>
            </body>
        </html>
    );
}
